export function addCurrent(knowledgebase) {
    return {
        type: 'ADD_CURRENT',
        knowledgebase,
    }
}
